
import React from "react";

const EmptyState = () => {
  return (
    <div className="text-center py-12">
      <p className="text-lg text-gray-600">No subscription plans available at the moment.</p>
      <p className="mt-2 text-sm text-gray-500">Please check back later or contact support.</p>
    </div>
  );
};

export default EmptyState;
